
import { Component, NgModule, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { DxButtonModule } from 'devextreme-angular/ui/button';

@Component({
    selector: 'schedule-of-charges-shortcut',
    templateUrl: './schedule-of-charges-shortcut.component.html',
    styleUrls: ['./schedule-of-charges-shortcut.component.scss'],
    imports: [DxButtonModule],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: true
})
export class ScheduleOfChargesShortcutComponent {
  constructor(private router: Router) {}

  onButtonClick() {
    //open new tab with url of Patricia
    this.router.navigate(['/finance-schedule-of-charges']);
  }
}
